<template>
  <div class="videoPreview">
    <div class="videoUrl">
      <slot></slot>
      <Button
        v-if="!showSlot"
        :loading="uploadLoading"
        style="position: relative"
      >
        {{ uploadLoading ? '上传中' : '点击上传' }}
        <!-- <span style="position: relative;
        top: -2px; left: 6px; font-size: 16px">{{ title }}</span> -->
      </Button>

      <input
        type="file"
        class="filepath"
        :accept="accept"
        :style="{ width: btnWidth ? btnWidth + 'px' : '90px' }"
        ref="upload"
        @change="getFile($event)"
      />
      <!-- <Upload action="/" :before-upload="getFile">
                  <Button icon="ios-cloud-upload-outline">点击上传</Button>
                </Upload> -->
    </div>
  </div>
</template>

<script>
// import image from '@/assets/images/image.png'
import { upload } from '@/api/common'
export default {
  name: 'fileUpload',
  props: {
    src: null,
    width: null,
    height: null,
    type: null,
    multi: null,
    uploadFunc: null,
    btnWidth: null,
    accept: '',
    index: Number,
    showSlot: Boolean,
    title: { type: String, default: '上传' }
  },
  data() {
    return {
      uploadLoading: false
    }
  },
  methods: {
    async getFile(event) {
      try {
        var file = event.target.files
        const formData = new FormData()
        formData.append('file', file[0])
        this.uploadLoading = true
        const func = this.uploadFunc ? this.uploadFunc : upload

        const { data } = await func(formData)
        this.$emit('handleSuccess', data)
      } finally {
        this.$refs.upload.value = null
        this.uploadLoading = false
      }
    },
    clearFile() {
      this.$refs.upload.value = null
    }
  }
}
</script>

<style scoped>
.videoPreview {
  text-align: center;
  display: flex;
  align-items: baseline;
}

.videoUrl {
  width: 100%;
  height: 100%;
  text-align: left;
  position: relative;
}

.filepath {
  top: 0;
  width: 90px;
  height: 100%;
  opacity: 0;
  position: absolute;
  left: 0;
}

.uploadimg {
  display: inline-block;
  width: 22px;
  height: 22px;
  position: relative;
  top: 3px;
  left: -5px;
}
</style>
